import { render, staticRenderFns } from "./GoodsMain.vue?vue&type=template&id=ca7451c4"
import script from "./GoodsMain.vue?vue&type=script&lang=js"
export * from "./GoodsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports